module.exports = __webpack_public_path__ + "media/src/application/images/squares-4fcb0996643ad3a2cdf01600adefc3f1.svg";